<template>
  <div class>
    <div class="discussion-header mb20">
      <h2 class="title">
        {{ i18n.t('member.forums.page_title') }}
      </h2>
      <view-type-selector v-if="showViewTypeSelector" class="view-type-selector" @view-type-selected="setViewType" />
      <thread-create-control v-if="canPost" class="create-control" :create-path="messageThreadsIndexPath"
                             @created-thread="onThreadCreated" />
    </div>
    <thread-list :list-path="messageThreadsIndexPath" :view-type="viewType" />
  </div>
</template>

<script>
import ThreadList from './thread-list'
import ThreadCreateControl from './thread-create-control'
import ViewTypeSelector from './view-type-selector'
import { mapMutations, mapState } from 'vuex'

export default {
  components: { ThreadCreateControl, ThreadList, ViewTypeSelector },
  props: {
    messageThreadsIndexPath: {
      type: String,
      required: true
    },
    currentUser: {
      type: Object,
      required: true
    },
    canPost: {
      type: Boolean,
      required: true
    },
    canFlag: {
      type: Boolean,
      required: true
    },
    canDelete: {
      type: Boolean,
      required: true
    },
    showViewTypeSelector: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState(['viewType'])
  },
  created() {
    this.$store.dispatch('getThreads', {url: this.messageThreadsIndexPath})
    this.$store.commit('setCanDelete', this.canDelete)
    this.$store.commit('setCanPost', this.canPost)
    this.$store.commit('setCanFlag', this.canFlag)
    this.$store.commit('setCurrentUser', this.currentUser)

    if (this.showViewTypeSelector) {
      this.setViewType()
    }
  },
  methods: {
    ...mapMutations(['setViewType']),
    onThreadCreated() {
      this.$store.dispatch('getThreads', {url: this.messageThreadsIndexPath})
    }
  }
}
</script>

<style scoped lang="scss">
  @use "~common_styles/breakpoints" as breakpoints;

  .discussion-header {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-end;
  }

  .title {
    flex-grow: 1;
  }

  .view-type-selector {
    flex-grow: 1.5;
  }

  @include breakpoints.screen-mobile-only {
    .title {
      flex-grow: 0;
      flex-basis: 100%
    }
  }
</style>
